export default "__VITE_ASSET__CTdCNqXk__"